import { createAsyncThunk } from "@reduxjs/toolkit";
import { IGetQuotationRequest } from "../models/request/IGetQuotationRequest";
import { formPostApi, getFormApi, getQuoteApi } from "./quoteCrud";

export const getFormThunk = createAsyncThunk(
  "auth/getForm",
  async (_, { rejectWithValue }) => {
    try {
      return await getFormApi();
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get Form failed"
      );
    }
  }
);

export const getQuoteThunk = createAsyncThunk(
  "auth/getQuote",
  async (queryParams: IGetQuotationRequest, { rejectWithValue }) => {
    try {
      return await getQuoteApi(queryParams);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get Quote failed"
      );
    }
  }
);

export const formPostThunk = createAsyncThunk(
  "auth/formPost",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      return await formPostApi(formData);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Form Post failed"
      );
    }
  }
);
